import React from 'react'
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white py-10 px-4">
      <div className="max-w-6xl mx-auto grid gap-8 md:grid-cols-3 text-center md:text-left">

        {/* Brand + Local Signal */}
        <div>
          <h3 className="text-lg font-semibold mb-2">2merative</h3>
          <p className="text-sm text-blue-100 mb-2">
            Web design Adelaide services for businesses looking to grow online with clarity and confidence.
          </p>
          <p className="text-sm text-blue-200">
            Adelaide, South Australia
          </p>
        </div>

        {/* Internal Links */}
        <div>
          <h4 className="text-sm font-semibold mb-3 uppercase tracking-wide text-blue-200">
            Explore
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/web-design-adelaide" className="hover:text-blue-300 transition">
                Web Design
              </Link>
            </li>
            <li>
              <Link to="/portfolio" className="hover:text-blue-300 transition">
                Portfolio
              </Link>
            </li>
            <li>
              <Link to="/whywebsites" className="hover:text-blue-300 transition">
                Why Websites
              </Link>
            </li>
            <li>
              <Link to="/website-health-check" className="hover:text-blue-300 transition">
                Website Health Check
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-blue-300 transition">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Social + Legal */}
        <div className="flex flex-col items-center md:items-end gap-4">
          <div className="flex items-center gap-4 text-xl">
            <a
              href="https://www.linkedin.com/company/2merative"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="hover:text-blue-300 transition"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/share/188qhAZZwo/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="hover:text-blue-300 transition"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/2merative"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="hover:text-blue-300 transition"
            >
              <FaInstagram />
            </a>
          </div>

          <p className="text-sm text-blue-200">
            © {new Date().getFullYear()} 2merative
          </p>

          <Link
            to="/terms"
            className="text-sm underline hover:text-blue-300 transition"
          >
            Terms & Conditions
          </Link>
        </div>
      </div>
    </footer>
  )
}
